// import { Link, useNavigate } from "react-router-dom";
// import { useAuth } from "../hooks/useAuth";
// import { signOut } from "firebase/auth";
// import { auth, db } from "../firebase";
// import { useEffect, useState } from "react";
// import { doc, getDoc } from "firebase/firestore";

// export default function AuthMenu() {
//   const { user } = useAuth();
//   const navigate = useNavigate();
//   const [userData, setUserData] = useState(null);

//   useEffect(() => {
//     const fetchUser = async () => {
//       if (user) {
//         const docRef = doc(db, "users", user.uid);
//         const snap = await getDoc(docRef);
//         if (snap.exists()) {
//           setUserData(snap.data());
//         }
//       }
//     };

//     fetchUser();
//   }, [user]);

//   const handleLogout = async () => {
//     await signOut(auth);
//     navigate("/");
//   };

//   if (!user) {
//     return (
//       <div className="d-flex align-items-center gap-2">
//         <span className="text-dark">
//           <Link to="/Registration" className="fw-bold text-decoration-none">S'inscrire</Link>{" "}
//           <span className="text-muted">ou</span>{" "}
//           <Link to="/Identity/Account/Login" className="fw-bold text-decoration-none">se connecter</Link>
//         </span>
//         <div className="rounded-circle border p-2">
//           <i className="bi bi-person"></i>
//         </div>
//       </div>
//     );
//   }

//   const fullName = `${userData?.prenom || ""} ${userData?.nom || ""}`;
//   const initials = `${(userData?.prenom || "U")[0]}${(userData?.nom || "S")[0]}`.toUpperCase();

//   return (
//     <div className="dropdown">
//       <button
//         className="btn btn-outline-light dropdown-toggle d-flex align-items-center gap-2 text-dark"
//         type="button"
//         id="userDropdown"
//         data-bs-toggle="dropdown"
//         aria-expanded="false"
//       >
//         <span className="fw-semibold">{fullName}</span>
//         <div className="rounded-circle border p-2 bg-light text-dark fw-bold" style={{ width: 35, height: 35, display: "flex", alignItems: "center", justifyContent: "center" }}>
//           {initials}
//         </div>
//       </button>
//       <ul className="dropdown-menu dropdown-menu-end mt-2" aria-labelledby="userDropdown">
//         <li><Link className="dropdown-item" to="/profil">Mon profil</Link></li>
//         <li><Link className="dropdown-item" to="/favoris">Mes favoris</Link></li>
//         <li><hr className="dropdown-divider" /></li>
//         <li><button className="dropdown-item text-danger" onClick={handleLogout}>Déconnexion</button></li>
//       </ul>
//     </div>
//   );
// }

import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { signOut } from "firebase/auth";
import { auth, db } from "../firebase";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { BiChevronDown } from "react-icons/bi";

export default function AuthMenu() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    const fetchUser = async () => {
      if (user) {
        const docRef = doc(db, "users", user.uid);
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          setUserData(snap.data());
        }
      }
    };

    fetchUser();
  }, [user]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/");
  };

  const fullName = `${userData?.prenom || ""} ${userData?.nom || ""}`;
  const initials = `${(userData?.prenom || "U")[0]}${(userData?.nom || "S")[0]}`.toUpperCase();

  return (
    <div className="dropdown">
      <button
        className="btn btn-light dropdown-toggle d-flex align-items-center gap-2"
        type="button"
        id="userDropdown"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {user ? (
          <>
            {!isMobile && <span className="fw-semibold text-dark">{fullName}</span>}
            <div
              className="rounded-circle border bg-white text-dark fw-bold"
              style={{
                width: 35,
                height: 35,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {initials}
            </div>
          </>
        ) : (
          <>
            <div
              className="rounded-circle border bg-white text-dark fw-bold"
              style={{
                width: 35,
                height: 35,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i className="bi bi-person"></i>
            </div>
          </>
        )}
      </button>

      <ul className="dropdown-menu dropdown-menu-end mt-2" aria-labelledby="userDropdown">
        {!user ? (
          <>
            <li>
              <Link className="dropdown-item" to="/Identity/Account/Login">Se connecter</Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/Registration">Registre</Link>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link className="dropdown-item" to="/profil">Mon profil</Link>
            </li>
            <li>
              <Link className="dropdown-item" to="/favoris">Mes favoris</Link>
            </li>
            <li><hr className="dropdown-divider" /></li>
            <li>
              <button className="dropdown-item text-danger" onClick={handleLogout}>Déconnexion</button>
            </li>
          </>
        )}
      </ul>
    </div>
  );
}
